import script from "./HaveAnIdea.vue?vue&type=script&setup=true&lang=js"
export * from "./HaveAnIdea.vue?vue&type=script&setup=true&lang=js"

import "./HaveAnIdea.vue?vue&type=style&index=0&id=d6c36f5c&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6c36f5c"]])

export default __exports__